import React, { Component } from 'react';
import s from './EditCancelReasonForm.css';
import { Field, reduxForm, getFormValues, change, formValueSelector } from 'redux-form';
import submit from './submit';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
//Style
import cx from 'classnames';
import {
    Button,
    Form,
    Col,
    Card,
    Row,
    InputGroup
} from 'react-bootstrap';
import Link from '../../Link';
import messages from '../../../locale/messages';
import validate from './validate';

export class EditCancelReasonForm extends Component {

    renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder }) => {
        return (
            <Form.Group>
                <Form.Label>{label}</Form.Label>
                <Form.Control {...input} placeholder={placeholder} type={type} className={fieldClass} />
                {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{error.defaultMessage}</span>}
            </Form.Group>
        )
    }

    render() {
        const { handleSubmit } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            
            <div className={cx('cardSection', s.widthInner, s.space5, s.responsiveNoPadding)}>
                <Row>
                    <Col md={12} lg={12} sm={12} xs={12} className={s.responsiveNoPadding}>
                        <Card className={s.card}>
                            <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <h1>{formatMessage(messages.editCategory)}</h1>
                                </Col>
                                <Row>
                                    <Col lg={4} md={6} sm={6} xs={12}>
                                        <Form.Group className={s.formGroup}>
                                            <div>
                                                <Field
                                                    name="basePrice"
                                                    type="text"
                                                    placeholder={formatMessage(messages.minBasePrice)}
                                                    component={this.renderField}
                                                    label={formatMessage(messages.minBasePrice)}
                                                    labelClass={s.labelText}
                                                    fieldClass={s.formControlInput}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Col lg={12} md={12} sm={12} xs={12} className={cx(s.textAlignRight, s.spaceTop3)}>
                                    <Form.Group className={s.formGroup}>
                                        <Button
                                            type="submit"
                                            className={cx(s.button, s.btnPrimary)}
                                        >
                                            {formatMessage(messages.submitButton)}
                                        </Button>
                                        <Link to={"/siteadmin/category"} className={cx(s.backBtn, s.btnSecondary, 'backBtnBorderRTL')} >{formatMessage(messages.goBack)}</Link>
                                    </Form.Group>
                                </Col>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

EditCancelReasonForm = reduxForm({
    form: 'EditCancelReasonForm',
    // onSubmit: submit,
    // validate
})(EditCancelReasonForm);

const mapState = (state) => ({
    
})

const mapDispatch = {
    
}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(EditCancelReasonForm)));
